function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import shallow from 'zustand/shallow';
import useStore from './../store.js';
/**
 * Simple component that returns nothing.
 * Initializes language and listens for changes
 * to languages object (which will be updated as
 * files are downloaded.)
 */

var LangManager = function LangManager(_ref) {
  var props = _extends({}, _ref);

  var _useStore = useStore(function (state) {
    return {
      activeLang: state.activeLang,
      getLang: state.getLang,
      // langs: state.langs,
      langUpdates: state.langUpdates
    };
  }, shallow),
      activeLang = _useStore.activeLang,
      getLang = _useStore.getLang,
      langUpdates = _useStore.langUpdates;

  var initLang = function initLang() {
    i18n.init({
      locale: activeLang,
      languages: {
        en_us: getLang(activeLang)
      }
    });
  };

  useEffect(function () {
    // console.log('langs changed, ', getLang(activeLang))
    initLang();
  }, [langUpdates]);
  initLang();
  return null;
};

LangManager.propTypes = {};
export default LangManager;